import pkg from '../../package.json';

export const environment = {
  production: true,
  /**
   * Whether this build is the development one, which is every build but
   * production's: the header and the footer say so, and the tab title carries it
   * too, so a dev cortito is never mistaken for a real one.
   */
  dev: true,
  /**
   * The key the development site asks for before it shows itself.
   *
   * Not a secret, and not because of this repository — it is private. It travels
   * in the bundle that `dev.corti.to` hands to anybody who asks for it, so
   * whoever wants it can read it out of the JavaScript. What it stops is somebody
   * wandering in, not somebody trying to get in. Production has no gate at all.
   */
  devKey: 'rWdPY-FV9XK-8VJNG',
  baseUrl: 'dev.corti.to/',
  firebase: {
    apiKey: 'AIzaSyDs4uq93dvRVPt2Pxgm7VdYqNnss6KM9Lw',
    // Firebase Hosting serves the sign-in pages under this domain already, so
    // they are first-party — which is what signing in by leaving the page needs.
    // Production has to proxy them instead; see `main.py`.
    authDomain: 'corti-to-dev.web.app',
    databaseURL: 'https://corti-to-dev.firebaseio.com',
    projectId: 'corti-to',
    messagingSenderId: '392700478156',
  },
  appVersion: pkg.version,
};
